import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'

export enum GenericInfoScreenContext {
  ABOUT,
  PRIVACY_POLICY,
  USE_TERMS,
}

export const getGenericInfoScreenHeaderTitle = (context: GenericInfoScreenContext) => {
  switch (context) {
    case GenericInfoScreenContext.ABOUT:
      return formatMessage(messages.profileScreen_aboutBrio)
    case GenericInfoScreenContext.PRIVACY_POLICY:
      return formatMessage(messages.profileScreen_privacyPolicy)
    case GenericInfoScreenContext.USE_TERMS:
      return formatMessage(messages.profileScreen_useTerms)
    default:
      return ''
  }
}
